import React from 'react';
import * as _ from 'lodash';
import config from '../config';

export interface IFeatureContext {
  featureName: string;
  enabled: boolean;
}

const context = React.createContext<IFeatureContext[]>([]);

export default context;
